import { Box } from '@mui/material';
import type { FC, ReactNode } from 'react';

type AvaniScrollableProps = {
  children: ReactNode;
  height?: number;

  width?: number;
  sx?: any;
  horizontal?: boolean;
};

export const AvaniScrollable: FC<AvaniScrollableProps> = ({ children, width, height, sx, horizontal }) => {
  return (
    <Box
      width={'100%'}
      height={height ?? '100%'}
      sx={{
        overflow: 'auto',
        paddingRight: 1,
        paddingBottom: 1,
        ...sx
      }}
    >
      {horizontal && (
        <Box
          sx={{
            width: width
          }}
        >
          {children}
        </Box>
      )}
      {!horizontal && children}
    </Box>
  );
};
